import React from 'react';
import {connect} from 'react-redux';
import {
    ActionDescriptorsTenderPurposes, ActionTenderPurposeAdd,
    ActionTenderPurposeDelete,
    ActionTenderPurposeEdit
} from "../../../parts/actions";
import ColumnResizer from "react-column-resizer";
import Storege from "../../../storage/storage";
import ToolButtons from "../../../parts/ToolButtons";
import Search from "../../../parts/Search";
import TenderTypesPurpose from "./TenderPurposePopup";
import RemoveButton from "../../../parts/removeBtn";
import CommonTab from "../../../parts/CommonTabClass";
import EditBtn from "../../../parts/EditBtn";

class TenderPurposesDescriptorComponent extends CommonTab {

    orderFields = {
        "Tender Type Name" : "tenderpurposename",
        "Tender Type Name Eng": "tenderpurposenameeng"
    };

    state = {
        tenderPurposes: {},
        popup: false,
        popupType: undefined,
        rowIndex: -1,
        currentItemIndex: -1,
        filteredItems: [],
        order: null
    };

    constructor(props) {
        super(props);
        this.state.tenderPurposes = props.tenderPurposes;
    }

    changeState = (name, e, id) => {
        let temp = this.props.tenderPurposes;
        temp.forEach(function (item) {
            if (item.tenderpurposeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            tenderPurposes: Object.assign({}, temp)
        });
    };

    changePopupType = (actionType) => {
        this.setState({
            popupType: actionType
        })
    };

    changePopupState = () => {
        let currentPopupState = this.state.popup;
        this.setState(
            {
                popup: !currentPopupState
            }
        )
    };

    addContentType = (object) => {
        console.log(object);
        ActionTenderPurposeAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD TENDER PURPOSE',
                item: data
            });
            this.changePopupState();
        });
    };

    editContentType = (object) => {
        console.log(object);
        ActionTenderPurposeEdit(object.tenderpurposeid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE TENDER PURPOSE',
                item: data,
                id: data.tenderpurposeid
            });
            this.changePopupState();
        });
    };

    changeState = (name, e, id) => {
        let temp = this.props.tendersTypes;
        temp.forEach(function (item) {
            if (item.tenderpurposeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            tendersTypes: Object.assign({}, temp)
        });
    };

    search = (value) => {
        if (value.length) {
            let filteredArray = this.props.tenderPurposes.filter(item => {
                return item.tenderpurposename.toLowerCase().indexOf(value.toLowerCase()) != -1 || item.tenderpurposenameeng.toLowerCase().indexOf(value.toLowerCase()) != -1;
            });
            this.setState({
                filtered: true,
                filteredItems: filteredArray
            });
        } else {
            this.setState({
                filtered: false
            });
        }
    };

    render() {
        if (!this.props.tenderPurposes.length) {
            ActionDescriptorsTenderPurposes();
        }
        let {filtered, filteredItems} = this.state;
        let {tenderPurposes} = this.props;
        let list = filtered ? filteredItems : tenderPurposes;
        if (!list) {
            return (
                <div className="overlay-loader">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }
        this.sortResults(list);
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        <div className="inline-toolbuttons">
                            <h3>Tender Purposes:</h3>
                            <div className={'tool-bar'}>
                                <ToolButtons
                                    actionType={this.changePopupType}
                                    popupChange={this.changePopupState}
                                    id={this.state.currentItemIndex}
                                />
                                <Search
                                    change={this.search}
                                />
                            </div>
                        </div>
                        <table className='table table-striped'>
                            <thead>
                            {this.orderPanel()}
                            </thead>
                            <tbody>
                            {(list ? list : []).map((item, index) => {
                                return (
                                    <tr key={index} onClick={
                                        e => {
                                            e.preventDefault();
                                            this.setState({
                                                rowIndex: index,
                                                currentItemIndex: item.tenderpurposeid
                                            });
                                        }
                                    } className={this.state.rowIndex == index ? 'active' : ''}>
                                        <td className={'flex-row'}>
                                            <RemoveButton
                                                action={ActionTenderPurposeDelete}
                                                id={item.tenderpurposeid}
                                                descriptor={'REMOVE TENDER PURPOSE'}
                                            />
                                            <EditBtn
                                                actionType={this.changePopupType}
                                                popupChange={this.changePopupState}
                                                change={this.setCurrentIndex}
                                                id={item.tenderpurposeid}
                                            />
                                        </td>
                                        <td>{item.tenderpurposename}</td>
                                        <ColumnResizer className="columnResizer" minWidth={5}/>
                                        <td>{item.tenderpurposenameeng}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.popup ? <TenderTypesPurpose
                    close={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        tenderPurposes: state.tendersPurposes
    }
};
const DescriptorTenderPurposes = connect(mapStateToProps)(TenderPurposesDescriptorComponent);

export default DescriptorTenderPurposes;